"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('bson'),
    ObjectId = _require.ObjectId;

var tv4 = require('tv4');

var _require2 = require('lodash'),
    isEqual = _require2.isEqual;

var CATALOG_TYPE = require('../../constant/library/catalog-type.constant');

var BioDetails = require('./details/bio-details');

var PPEDetails = require('./details/ppe-details');

var LibraryItem = /*#__PURE__*/function () {
  function LibraryItem(opt) {
    _classCallCheck(this, LibraryItem);

    this._id = null;
    this.catalog = null;
    this.name = null;
    this.description = null;
    this.tags = null;
    this.details = null;

    if (opt) {
      this.fillObject(_objectSpread({}, opt));
    }
  }

  _createClass(LibraryItem, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.catalog = opt.catalog || null;
      this.name = opt.name || null;
      this.description = opt.description || null;
      this.tags = opt.tags || [];

      switch (opt.catalog) {
        case CATALOG_TYPE.BIOLOGICAL:
          this.details = new BioDetails(opt.details);
          break;

        case CATALOG_TYPE.EQUIPMENT:
          this.details = null;
          break;

        case CATALOG_TYPE.PPE:
          this.details = new PPEDetails(opt.details);
          break;

        case CATALOG_TYPE.SERVICES:
          this.details = null;
          break;

        default:
          this.details = null;
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      var validation = tv4.validateMultiple(this, LibraryItem.schema());
      var isDetailsValid = this.validateDetails(this.catalog, this.details);

      if (!isDetailsValid) {
        validation.errors.push(new Error("Invalid details for catalog ".concat(this.catalog)));
        validation.valid = false;
      }

      return validation;
    }
  }, {
    key: "validateDetails",
    value: function validateDetails() {
      var catalog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.catalog;
      var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.details;

      switch (catalog) {
        case CATALOG_TYPE.PPE:
          return new PPEDetails(details).validate().valid;

        case CATALOG_TYPE.BIOLOGICAL:
          return isEqual(Object.keys(details).sort(), Object.keys(new BioDetails()).sort());

        default:
          return false;
      }
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'library-item.schema.json',
        title: 'library Item Schema',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          catalog: {
            "enum": Object.keys(CATALOG_TYPE)
          },
          name: {
            type: 'string'
          },
          description: {
            type: ['string', 'null']
          },
          tags: {
            type: 'array',
            minItems: 1
          },
          details: {
            oneOf: [{
              $ref: 'library-item.bio.details.schema.json'
            }, {
              $ref: 'library-item.ppe.details.schema.json'
            }, {
              type: 'null'
            }]
          }
        },
        required: Object.keys(new LibraryItem())
      };
    }
  }]);

  return LibraryItem;
}();

tv4.addSchema(BioDetails.schema());
tv4.addSchema(PPEDetails.schema());
module.exports = LibraryItem;